<template>
	<div class="secondCard" :style="{ position: isTip ? 'relative' : 'unset' }">
		<img v-if="!isTip" style="width: 1280px; height: 433px; position: relative; left: -40px; top: -40px;" src="../../../assets/icon_dean_home_bg_card_1.png" alt="" />
		<img v-if="isTip" style="width: 1280px; height: 433px; position: absolute; left: -40px; top: -40px;" src="../../../assets/icon_dean_home_bg_card_1_1.png" alt="" />
		<div style="position: absolute; width: 1200px; height: 353px;">
		
		
			<div style="display: flex; flex-direction: column; width: 100%; height: 100%;" :style="{pointerEvents: isTip ? 'none' : 'unset'}">
				<div style="display: flex; height: 39px; justify-content: space-between;">
					<div style="display: flex; align-items: center; align-self: flex-end;">
						<div style="width: 5px; height: 20px; background: #4A7CE8; border-radius: 0px 3px 3px 0px"></div>
						<div style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #1F2635; line-height: 24px; margin-left: 15px;">需要长期观察的长者</div>
						<div style="display: flex; align-items: center; margin-left: 5px;" :style="{opacity: !data ? 0 : 1}">
							<img style="width: 7px; height: 8px; z-index: 1;" src="../../../assets/icon_common_special_arrow_2.png" alt="" />
							<div style="margin-left: -2px; background: #FBF6CB; border-radius: 4px; border: 1px solid #ECE271; padding: 2px 5px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #E6BA0A; line-height: 20px;">{{ dataLength + '位' }}</div>
						</div>
					</div>
					<div v-if="data && dataLength > 0" style="display: flex; align-items: center; align-self: flex-end; margin-bottom: 7px;">
						<img style="width: 73px; height: 14px; margin-right: 10px;" src="../../../assets/icon_dean_home_bg_card_icon_1.png" alt="" />
						<div style="display: flex; align-items: center; margin-right: 20px;" @click="seeAll()">
							<div style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #4A7CE8; line-height: 22px; margin-right: 2px; cursor: pointer;">查看全部</div>
							<img style="width: 16px; height: 16px;" src="../../../assets/icon_dean_home_bg_card_icon_8.png" alt="" />
						</div>
					</div>
				</div>
				<div v-if="!data" style="width: 1160px; height: 274px; background: #ECF0F3; box-shadow: inset 8px 8px 20px 0px #D1D9E6, inset -8px -8px 20px 0px #FFFFFF; border-radius: 16px; margin-top: 20px; margin-left: 20px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
					<img v-if="emptyString != '院长端未关联任何设备'" style="width: 107px; height: 107px; z-index: 1;" :src="require(emptyString == '所有设备离线，请尽快检查设备情况，恢复守护状态' ? '../../../assets/icon_dean_home_card_empty_icon_1.png' : emptyString == '睡眠设备赶紧用起来才能看到更多内容哦' ? '../../../assets/icon_dean_home_card_empty_icon_2.png' : '../../../assets/icon_dean_home_card_empty_icon_3.png')" alt="" />
					<div v-if="emptyString != '院长端未关联任何设备'" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 20px; margin-top: 15px;">{{ emptyString || ' ' }}</div>
				</div>
				<div v-if="data" style="height: 314px; display: flex; flex-direction: column;">
					<div style="height: 234px; position: relative;">
						<div style="height: 100%; position: absolute; z-index: 0; width: 100%;">
							<el-carousel :interval="5000000" arrow="never" height="234px" :loop="false" indicator-position='none' ref="homeDeanSecondCardRef" @change="carouselChange" >
								<el-carousel-item v-for="(item,index) in data || []" :key="index" >
									<div style="width: 100%; height: 100%; display: flex; padding-left: 20px;">
										<div class="miniCardHover" @click="itemClick(subItem)" v-for="(subItem,subIndex) in item || []" style="width: 220px; height: 199px; box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF; border-radius: 16px; display: flex; flex-direction: column;" :style="{marginRight: subIndex == 4 ? '0px' : '15px'}">
											<div style="flex: 1; display: flex; position: relative; justify-content: center;">
												<div style="flex: 1; margin-bottom: 10px; margin-left: 5px; margin-right: 5px; margin-top: 5px; background: #FAFAF0; border-radius: 12px; border: 1px solid #ECE271; display: flex; flex-direction: column; justify-content: space-between;">
													<div class="richTextDiv" style="display: flex; flex-wrap: wrap; overflow: hidden; max-height: 108px; align-items: flex-start; justify-content: flex-start;">
														<div 
														class="description"
														v-for="(miniItem, miniIndex) in subItem.hasOccurPrfList || []" 
														style="background: rgba(235, 210, 16, 0.15); border-radius: 8px; height: 40px; margin-top: 10px; display: flex; align-items: center; position: relative; margin-left: 10px; padding-left: 10px; padding-right: 10px;"
														>
															<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 170px;">{{ miniItem }}</div>
														</div>
													</div>
													<div style="display: flex; height: 34px; justify-content: space-between; margin-bottom: 10px; padding-left: 10px; padding-right: 10px;">
														<div style="width: 38px; height: 24px; background: rgba(94, 103, 121, 0.1); border-radius: 19px 19px 19px 2px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; display: flex; align-items: center; padding-left: 8px;" :style="{opacity: subItem && subItem.hasOccurPrfList && subItem.hasOccurPrfList.length > 3 ? 1 : 0}">…</div>
														<div style="width: 58px; height: 30px; background: rgba(74, 124, 232, 0.15); border-radius: 20px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #4A7CE8; line-height: 20px; display: flex; justify-content: center; align-items: center; align-self: flex-end;">查看</div>
													</div>
												</div>
												<img style="position: absolute; width: 16px; height: 12px; bottom: 0px;" src="../../../assets/icon_common_special_arrow_4.png" alt="" />
											</div>
											<div class="bedName" style="display: flex; margin-bottom: 10px; align-items: center; justify-content: center; padding-left: 10px; padding-right: 10px; position: relative;">
												<div class="miniCardHoverImg" style="width: 20px; height: 20px; margin-right: 5px;" alt=""></div>
												<div class="miniCardHoverText" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 175px;">{{ subItem.bedName || '' }}</div>
												<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; top: -40px; padding: 10px; border-radius: 8px; display: none; z-index: 10000;" :style="{transform: subIndex == 4 ? 'translateX(-50%)' : 'translateX(50%)'}">
													<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: wrap; overflow-wrap: break-word; color: rgba(94, 103, 121, 1);">{{ subItem.bedName || '' }}</div>
												</div>
											</div>
										</div>
									</div>
								</el-carousel-item>
							</el-carousel>
						</div>
						<img 
						style="position: absolute; width: 96px; height: 96px; left: -5px; top: 75px; z-index: 1; cursor: pointer;"
						:src="require('../../../assets/' + (leftBtnState == 1 ? 'icon_dean_home_bg_card_icon_12' : 'icon_dean_home_bg_card_icon_11') + '.png')" 
						onselectstart="return false" 
						alt=""
						@click="clickArrow(1)"
						v-if="currentPage != 1"
						@mouseover="leftBtnHover"
						@mouseout="leftBtnRemoveHover"
						/>
						<img 
						style="position: absolute; width: 96px; height: 96px; right: -5px; top: 75px; z-index: 1; cursor: pointer;"
						:src="require('../../../assets/' + (rightBtnState == 1 ? 'icon_dean_home_bg_card_icon_14' : 'icon_dean_home_bg_card_icon_13') + '.png')" 
						onselectstart="return false" 
						alt=""
						@click="clickArrow(2)"
						v-if="currentPage != data.length"
						@mouseover="rightBtnHover"
						@mouseout="rightBtnRemoveHover"
						/>
					</div>
					<div style="display: flex; margin-left: 20px;">
						<div style="background: rgba(255,255,255,0.8); border-radius: 16px; border: 1px solid #FFFFFF; height: 60px; position: relative; display: flex; align-items: center;">
							<img style="width: 20px; height: 20px; position: absolute; left: -3px; top: -3px;" src="../../../assets/icon_dean_home_bg_card_icon_9.png" alt="" />
							<img style="width: 20px; height: 20px; position: absolute; right: -3px; bottom: -3px;" src="../../../assets/icon_dean_home_bg_card_icon_10.png" alt="" />
							<img style="width: 22px; height: 22px; margin-left: 20px;" src="../../../assets/icon_dean_home_bg_card_icon_2.png" alt="" />
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; margin-left: 5px;">日常生活协助</div>
							<div style="width: 1px; height: 20px; background: #D5DADF; margin-left: 15px;"></div>
							<img style="width: 22px; height: 22px; margin-left: 20px;" src="../../../assets/icon_dean_home_bg_card_icon_3.png" alt="" />
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; margin-left: 5px;">慢病跟踪</div>
							<div style="width: 1px; height: 20px; background: #D5DADF; margin-left: 15px;"></div>
							<img style="width: 22px; height: 22px; margin-left: 20px;" src="../../../assets/icon_dean_home_bg_card_icon_4.png" alt="" />
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; margin-left: 5px;">心理疏导</div>
							<div style="width: 1px; height: 20px; background: #D5DADF; margin-left: 15px;"></div>
							<img style="width: 22px; height: 22px; margin-left: 20px;" src="../../../assets/icon_dean_home_bg_card_icon_5.png" alt="" />
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; margin-left: 5px; margin-right: 20px;">康复&助眠等服务</div>
						</div>
					</div>	
				</div>
			</div>
		</div>

		<div v-if="isTip" style="position: absolute; top: -200px; left: 336px; display: flex; flex-direction: column; align-items: center;">
			<div style="width: 529px; background: #5E6779; border-radius: 8px; padding-left: 20px; padding-right: 20px; padding-top: 20px; padding-bottom: 15px">
				<div style="background: rgba(255, 255, 255, 0.1); border-radius: 6px; padding-left: 15px; padding-right: 15px; padding-top: 10px; padding-bottom: 10px; position: relative;">
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF00; line-height: 24px; width: 100%; white-space: wrap;">
						·黄区老人可以看情况筛选关心：根据对老人实际健康状态的了解程度，周期性合理的进行慢病跟踪（例如：呼吸急促的老人、频繁起夜的老人等）
					</div>
					<div style="position: absolute; height: 8px; background: rgba(243, 183, 61, 0.3); left: 120px; top: 25px; width: 110px; height: 8px;"></div>
					<div style="position: absolute; height: 8px; background: rgba(243, 183, 61, 0.3); left: 320px; top: 49px; width: 63px; height: 8px;"></div>
					<div style="position: absolute; height: 8px; background: rgba(243, 183, 61, 0.3); left: 447px; top: 49px; width: 16px; height: 8px;"></div>
					<div style="position: absolute; height: 8px; background: rgba(243, 183, 61, 0.3); left: 15px; top: 73px; width: 47px; height: 8px;"></div>
					<div style="position: absolute; font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF; line-height: 24px; left: 15px; top: 10px; right: 15px;">
						·黄区老人可以看情况筛选关心：根据对老人实际健康状态的了解程度，周期性合理的进行慢病跟踪（例如：呼吸急促的老人、频繁起夜的老人等）
					</div>
				</div>
				<div style="margin-top: 15px; display: flex; justify-content: space-between; align-items: center;">
					<div style="display: flex;">
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 14px; color: rgba(255, 255, 255, 0.5); line-height: 24px;">2/3</div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 14px; color: rgba(255, 255, 255, 0.5); line-height: 24px; margin-left: 15px; cursor: pointer;" @click="skippingTutorial">跳过教程</div>
					</div>
					<div style="width: 72px; height: 30px; background: #4A7CE8; border-radius: 20px; font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #FFFFFF; line-height: 20px; display: flex; align-items: center; justify-content: center; cursor: pointer;" @click="next">下一步</div>
				</div>
			</div>
			<img style="width: 38px; height: 12px;" src="../../../assets/icon_home_hei_san_jiao_2.png" alt="" />
		</div>
		
		<SecondCardAllAlert ref="secondCardAllAlert" @itemClick="itemClick"></SecondCardAllAlert>
		<WorkProposalAlert ref="secondCardWorkProposalAlert" :type="1"></WorkProposalAlert>

	</div>
</template>
  
<script>
import SecondCardAllAlert from './secondCardAllAlert.vue'; 
import WorkProposalAlert from './workProposalAlert.vue'
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';

export default {
	components: {
		SecondCardAllAlert,
		WorkProposalAlert
	},
	filters: {
		reMate(val){
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {
		data: {
			type: Array,
			default: null
		},
		dataLength: {
			type: Number,
			default: 0
		},
		emptyString: {
			type: String,
			default: null
		},
		isTip: {
			type: Boolean,
			default: false
		}
	},
	watch: {
	},
	data() {
		return {
			leftBtnState: 0,
			rightBtnState: 0,
			currentPage: 1,
			hoverText: null
		};
	},
	created() { },
	mounted() {

	},
	methods: {
		carouselChange(){
			let activeIndex = this.$refs.homeDeanSecondCardRef.activeIndex
      		this.currentPage = Number(activeIndex + 1)
		},
		clickArrow(type) {
			if(type == 1){
				this.$refs.homeDeanSecondCardRef.prev()
			}else {
				this.$refs.homeDeanSecondCardRef.next()
			}
		},
		leftBtnHover() {
			this.leftBtnState = 1;
			this.rightBtnState = 0;
		},
		leftBtnRemoveHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 0;
		},
		rightBtnHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 1;
		},
		rightBtnRemoveHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 0;
		},
		seeAll() {
			this.$refs.secondCardAllAlert.openAlert()
		},
		itemClick(item) {
			this.$refs.secondCardWorkProposalAlert.openAlert(item)
		},
		// 跳过教程
		skippingTutorial() {
			this.$emit('skippingTutorial', 2);
		},
		// 下一步
		next() {
			this.$emit('next', 2);
		}
	},
};
</script>
<style lang="scss" scoped>
.secondCard {
	height: 353px;
	position: relative;
	display: flex;
	margin-top: 30px;
	margin-bottom: 30px;
}
.miniCardHover {
	margin-top: 20px;
	background: #ECF0F3;
	cursor: pointer;
	.miniCardHoverText {
		color: #5E6779;
	}
	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_6.png') no-repeat no-repeat;
		background-size: contain;
	}
}
.miniCardHover:hover {
	background: #DFE8FC;
	.miniCardHoverText {
		color: #4A7CE8;
	}
	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_7.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.richTextDiv ::v-deep {
	.richContentStyle {
		display: flex;
	}
	.richTextStyleNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
	}
	.richTextStyleRed {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 20px;
	}
}

.description:hover {
	.showDescription {
		display: block !important;
	}
}

.bedName:hover {
	.showDescription {
		display: block !important;
	}
}

</style>
  